<template>
 <div id="app">
  <div class="form__field">
   <div class="cell">
    <input @keyup.enter="queryResults" class="ids_topicSearch" id="ctl00_ids_contentPlaceHolder_ids_topicSearch" name="ctl00$ids_contentPlaceHolder$ids_topicSearch" placeholder="Search Contents" type="text" v-model="search"/>
   </div>
   <div class="search_button" v-if="search">
    <button @click="clearResult" class="close-icon">
     &times;
    </button>
   </div>
   <div class="search_button">
    <button @click="queryResults">
     <i class="fa fa-search">
     </i>
    </button>
   </div>
  </div>
  <div class="col-1 l-pad-top" id="results">
   <div>
    <p class="toc-2-style" style="margin-bottom: 10px;">
     <strong v-if="resultsCount != 0">
      ({{resultsCount}}) Results Found
     </strong>
     <strong v-else-if="resultsActual">
      No Results Found
     </strong>
    </p>
   </div>
   <div v-for="result of resultsActual">
    <p class="toc-2-style">
     <a :href="result.link" :keywords="result.keywords" onclick="reload(this.href, this.getAttribute('keywords'))">
      {{result.title}}
     </a>
    </p>
    <p class="toc-3-style">
     {{result.desc}}
    </p>
   </div>
  </div>
  <div class="side-toc" v-if="!resultsActual">
   <p class="toc-1-style">
    <a href="cover.html" title="Multifuncționale laser CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655">
     Multifuncționale laser CX833, CX961, CX962, CX963, XC8355, XC9635, XC9645, XC9655
    </a>
   </p>
   <p class="toc-1-style">
    <a href="safety.html#safety_ro" title="Informații de siguranță">
     Informații de siguranță
    </a>
   </p>
   <div id="divd0e18">
    <p class="toc-2-style">
     <a href=".html#d0e23" title="Convenții">
      Convenții
     </a>
    </p>
    <p class="toc-2-style">
     <a href="safety-cable-topic.html#d0e43" title="Declarații produs">
      Declarații produs
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="learning-about-printer-chapter.html#learning-about-printer-chapter_ro" title="Aflați despre imprimantă">
     Aflați despre imprimantă
    </a>
   </p>
   <div id="divd0e221">
    <p class="toc-2-style">
     <a href="finding-information-about-printer-topic.html#finding-information-about-printer_ro" title="Găsirea informațiilor despre imprimantă">
      Găsirea informațiilor despre imprimantă
     </a>
    </p>
    <p class="toc-2-style">
     <a href="finding-printer-serial-number-topic.html#finding-printer-serial-number_ro" title="Găsirea numărului de serie al imprimantei">
      Găsirea numărului de serie al imprimantei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-configurations-topic.html#printer-configurations_ro" title="Configurațiile imprimantei">
      Configurațiile imprimantei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-control-panel-topic.html#using-control-panel_ro" title="Utilizarea panoului de control">
      Utilizarea panoului de control
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-home-screen-topic.html#using-home-screen_ro" title="Pictogramele ecranului de pornire">
      Pictogramele ecranului de pornire
     </a>
    </p>
    <p class="toc-2-style">
     <a href="colors-of-indicator-light-topic.html#colors-of-indicator-light_ro" title="Culorile indicatorului luminos">
      Culorile indicatorului luminos
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-ADF-and-scanner-glass-copy-topic.html#using-ADF-and-scanner-glass-copy_ro" title="Utilizarea alimentatorului automat de documente şi a geamului scanerului">
      Utilizarea alimentatorului automat de documente şi a geamului scanerului
     </a>
    </p>
    <p class="toc-2-style">
     <a href="locating-security-slot-topic.html#locating-security-slot_ro" title="Localizarea slotului de securitate">
      Localizarea slotului de securitate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="paper-guidelines-topic.html#d0e769" title="Selectarea h&acirc;rtiei">
      Selectarea h&acirc;rtiei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="supported-applications-topic.html#d0e10655" title="Caracteristici și asistență suplimentare pentru imprimantă">
      Caracteristici și asistență suplimentare pentru imprimantă
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="setting-up-using-home-screen-apps-chapter.html#setting-up-using-home-screen-apps-chapter_ro" title="Configurarea și instalarea">
     Configurarea și instalarea
    </a>
   </p>
   <div id="divd0e10782">
    <p class="toc-2-style">
     <a href="selecting-location-printer-topic.html#selecting-location-printer_ro" title="Alegerea unui loc pentru imprimantă">
      Alegerea unui loc pentru imprimantă
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-ports-topic.html#printer-ports_ro" title="Porturile imprimantei">
      Porturile imprimantei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-scan-center-topic.html#d0e10981" title="Configurarea aplicațiilor și a soluțiilor">
      Configurarea aplicațiilor și a soluțiilor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="activating-voice-guidance-topic.html#d0e11158" title="Configurarea și utilizarea caracteristicilor de accesibilitate">
      Configurarea și utilizarea caracteristicilor de accesibilitate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-printer-to-fax-group.html#d0e11463" title="Configurarea imprimantei pentru fax">
      Configurarea imprimantei pentru fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="loading-trays-group.html#loading-trays-group_ro" title="&Icirc;ncărcarea h&acirc;rtiei și a suporturilor speciale">
      &Icirc;ncărcarea h&acirc;rtiei și a suporturilor speciale
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-printer-software-topic.html#d0e12259" title="Instalarea și actualizarea software-ului, a driverelor și a firmware-ului">
      Instalarea și actualizarea software-ului, a driverelor și a firmware-ului
     </a>
    </p>
    <p class="toc-2-style">
     <a href="installing-optional-550-sheet-tray-topic.html#d0e12585" title="Instalarea opțiunilor hardware">
      Instalarea opțiunilor hardware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="connecting-printer-to-wireless-network-topic.html#d0e14116" title="Lucrul &icirc;n rețea">
      Lucrul &icirc;n rețea
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="securing-the-printer.html#securing-the-printer_ro" title="Securizarea imprimantei">
     Securizarea imprimantei
    </a>
   </p>
   <div id="divd0e14468">
    <p class="toc-2-style">
     <a href="erasing-printer-memory-topic.html#erasing-printer-memory_ro" title="Ștergerea memoriei imprimantei">
      Ștergerea memoriei imprimantei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="erasing-printer-storage-drive-topic.html#erasing-printer-storage-drive_ro" title="Ștergerea datelor de pe unitatea de stocare a imprimantei">
      Ștergerea datelor de pe unitatea de stocare a imprimantei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="restoring-factory-default-settings-topic.html#restoring-factory-default-settings_ro" title="Revenirea la setările prestabilite din fabrică">
      Revenirea la setările prestabilite din fabrică
     </a>
    </p>
    <p class="toc-2-style">
     <a href="statement-of-volatility-topic.html#statement-of-volatility_ro" title="Declarație de volatilitate">
      Declarație de volatilitate
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printing-chapter.html#printing-chapter_ro" title="Imprimare">
     Imprimare
    </a>
   </p>
   <div id="divd0e14660">
    <p class="toc-2-style">
     <a href="printing-from-computer-topic.html#printing-from-computer_ro" title="Imprimarea de pe un computer">
      Imprimarea de pe un computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-mobile-device-using-lexmark-print-app-topic.html#d0e14711" title="Imprimarea de pe un dispozitiv mobil">
      Imprimarea de pe un dispozitiv mobil
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-from-flash-drive-topic.html#printing-from-flash-drive_ro" title="Imprimarea de pe o unitate flash">
      Imprimarea de pe o unitate flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-confidential-jobs-topic.html#configuring-confidential-jobs_ro" title="Configurarea lucrărilor de imprimare confidențiale">
      Configurarea lucrărilor de imprimare confidențiale
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-confidential-and-other-held-jobs-topic.html#printing-confidential-and-other-held-jobs_ro" title="Imprimarea lucrărilor confidențiale și a altor lucrări &icirc;n așteptare">
      Imprimarea lucrărilor confidențiale și a altor lucrări &icirc;n așteptare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-font-sample-list-topic.html#printing-font-sample-list_ro" title="Imprimarea unei liste de eșantioane de fonturi">
      Imprimarea unei liste de eșantioane de fonturi
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-directory-list-topic.html#printing-directory-list_ro" title="Imprimarea unei liste de directoare">
      Imprimarea unei liste de directoare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-in-print-jobs-topic.html#placing-separator-sheets-in-print-jobs_ro" title="Plasarea colilor de separare &icirc;n lucrările de imprimare">
      Plasarea colilor de separare &icirc;n lucrările de imprimare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="canceling-print-job-topic.html#canceling-print-job_ro" title="Anularea unei lucrări de imprimare">
      Anularea unei lucrări de imprimare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-toner-darkness-topic.html#adjusting-toner-darkness_ro" title="Reglarea luminozității tonerului">
      Reglarea luminozității tonerului
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="copying.html#copying_ro" title="Copiere">
     Copiere
    </a>
   </p>
   <div id="divd0e15206">
    <p class="toc-2-style">
     <a href="making-copies-topic.html#making-copies_ro" title="Realizare de copii">
      Realizare de copii
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-photos-topic.html#copying-photos_ro" title="Copierea fotografiilor">
      Copierea fotografiilor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-letterhead-topic.html#copying-on-letterhead_ro" title="Copierea pe h&acirc;rtie cu antet">
      Copierea pe h&acirc;rtie cu antet
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-on-both-sides-of-paper-topic.html#copying-on-both-sides-of-paper_ro" title="Copierea pe ambele fețe ale h&acirc;rtiei">
      Copierea pe ambele fețe ale h&acirc;rtiei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="reducing-or-enlarging-copies-topic.html#reducing-or-enlarging-copies_ro" title="Micșorarea sau mărirea copiilor">
      Micșorarea sau mărirea copiilor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="collating-copies-topic.html#collating-copies_ro" title="Asamblarea copiilor">
      Asamblarea copiilor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="placing-separator-sheets-between-copies-topic.html#placing-separator-sheets-between-copies_ro" title="Inserarea colilor de separare &icirc;ntre copii">
      Inserarea colilor de separare &icirc;ntre copii
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-multiple-pages-onto-single-sheet-topic.html#copying-multiple-pages-onto-single-sheet_ro" title="Copierea mai multor pagini pe o singură foaie">
      Copierea mai multor pagini pe o singură foaie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copying-cards-topic.html#copying-cards_ro" title="Copierea cărților de identitate">
      Copierea cărților de identitate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-copy-shortcut-topic.html#creating-copy-shortcut_ro" title="Crearea unei comenzi rapide pentru copiere">
      Crearea unei comenzi rapide pentru copiere
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="E-mailing.html#E-mailing_ro" title="Poștă electronică">
     Poștă electronică
    </a>
   </p>
   <div id="divd0e15479">
    <p class="toc-2-style">
     <a href="configuring-smtp-settings-topic.html#configuring-smtp-settings_ro" title="Configurarea setărilor SMTP">
      Configurarea setărilor SMTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="sending-email-topic.html#sending-email_ro" title="Trimiterea unui mesaj de poștă electronică">
      Trimiterea unui mesaj de poștă electronică
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-email-shortcut-topic.html#creating-email-shortcut-using-control-panel_ro" title="Crearea unei comenzi rapide pentru poștă electronică">
      Crearea unei comenzi rapide pentru poștă electronică
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="Faxing.html#Faxing_ro" title="Fax">
     Fax
    </a>
   </p>
   <div id="divd0e16928">
    <p class="toc-2-style">
     <a href="sending-fax-topic.html#sending-fax_ro" title="Trimiterea unui fax">
      Trimiterea unui fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scheduling-fax-topic.html#scheduling-fax_ro" title="Programarea unui fax">
      Programarea unui fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-fax-destination-shortcut-topic.html#creating-fax-destination-shortcut_ro" title="Crearea unei comenzi rapide pentru o destinație de fax">
      Crearea unei comenzi rapide pentru o destinație de fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="changing-fax-resolution-topic.html#changing-fax-resolution_ro" title="Schimbarea rezoluției faxului">
      Schimbarea rezoluției faxului
     </a>
    </p>
    <p class="toc-2-style">
     <a href="adjusting-fax-darkness-topic.html#adjusting-fax-darkness_ro" title="Ajustarea &icirc;ntunecimii faxului">
      Ajustarea &icirc;ntunecimii faxului
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-fax-log-topic.html#printing-fax-log_ro" title="Imprimarea unui jurnal de fax">
      Imprimarea unui jurnal de fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="blocking-junk-faxes-topic.html#blocking-junk-faxes_ro" title="Blocarea faxurilor nesolicitate">
      Blocarea faxurilor nesolicitate
     </a>
    </p>
    <p class="toc-2-style">
     <a href="holding-faxes-topic.html#holding-faxes_ro" title="Reținerea faxurilor">
      Reținerea faxurilor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forwarding-fax-topic.html#forwarding-fax_ro" title="Redirecționarea unui fax">
      Redirecționarea unui fax
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="FTP.html#FTP_ro" title="Scanare">
     Scanare
    </a>
   </p>
   <div id="divd0e17224">
    <p class="toc-2-style">
     <a href="scanning-to-computer-topic.html#scanning-to-computer_ro" title="Scanarea către un computer">
      Scanarea către un computer
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-ftp-server-using-control-panel-topic.html#scanning-ftp-server-using-control-panel_ro" title="Scanarea pe un server FTP">
      Scanarea pe un server FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-FTP-shortcut-topic.html#creating-FTP-shortcut_ro" title="Crearea unei comenzi rapide pentru FTP">
      Crearea unei comenzi rapide pentru FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-network-folder-topic.html#scanning-to-network-folder_ro" title="Scanare cu trimitere &icirc;ntr-un folder din rețea">
      Scanare cu trimitere &icirc;ntr-un folder din rețea
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-network-folder-destination-topic.html#configuring-network-folder-destination_ro" title="Configurarea unei destinații de tip folder de rețea">
      Configurarea unei destinații de tip folder de rețea
     </a>
    </p>
    <p class="toc-2-style">
     <a href="creating-network-folder-shortcut-topic.html#creating-network-folder-shortcut_ro" title="Crearea unei comenzi rapide pentru un folder din rețea">
      Crearea unei comenzi rapide pentru un folder din rețea
     </a>
    </p>
    <p class="toc-2-style">
     <a href="scanning-to-flash-drive-topic.html#scanning-to-flash-drive_ro" title="Scanarea către o unitate flash">
      Scanarea către o unitate flash
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="printer-menus-chapter.html#printer-menus-chapter_ro" title="Meniuri imprimantă">
     Meniuri imprimantă
    </a>
   </p>
   <div id="divd0e17513">
    <p class="toc-2-style">
     <a href="menu-map-topic.html#menu-map_ro" title="Hartă meniuri">
      Hartă meniuri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="preferences-topic.html#d0e17827" title="Dispozitiv">
      Dispozitiv
     </a>
    </p>
    <p class="toc-2-style">
     <a href="layout-topic.html#d0e20061" title="Imprimare">
      Imprimare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="tray-configuration-topic.html#d0e21343" title="Paper (H&acirc;rtie)">
      Paper (H&acirc;rtie)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="copy-defaults-topic.html#d0e21675" title="Copiere">
      Copiere
     </a>
    </p>
    <p class="toc-2-style">
     <a href="fax-defaults-subgroup.html#d0e22234" title="Fax">
      Fax
     </a>
    </p>
    <p class="toc-2-style">
     <a href="email-setup-topic.html#d0e24101" title="Poștă electronică">
      Poștă electronică
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ftp-defaults-topic.html#d0e25198" title="FTP">
      FTP
     </a>
    </p>
    <p class="toc-2-style">
     <a href="flash-drive-scan-topic.html#d0e25904" title="Unitate USB">
      Unitate USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="network-overview-topic.html#d0e26750" title="Network/Ports (Rețea/Porturi)">
      Network/Ports (Rețea/Porturi)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="login-methods-subgroup.html#d0e28901" title="Security (Securitate)">
      Security (Securitate)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cloud-services-enrollment-topic.html#d0e29998" title="Servicii cloud">
      Servicii cloud
     </a>
    </p>
    <p class="toc-2-style">
     <a href="menu-settings-page-topic.html#d0e30055" title="Reports (Rapoarte)">
      Reports (Rapoarte)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="troubleshooting-menu-topic.html#troubleshooting-menu_ro" title="Depanare">
      <strong>
       Depanare
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="forms-merge-topic.html#forms-merge_ro" title="&Icirc;mbinare formulare">
      <strong>
       &Icirc;mbinare formulare
      </strong>
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printing-menu-settings-page-topic.html#printing-menu-settings-page_ro" title="Imprimarea Paginii setări meniu">
      Imprimarea
      <strong>
       Paginii setări meniu
      </strong>
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="using-printer-finisher-options-chapter.html#using-printer-finisher-options-chapter_ro" title="Opțiuni finisor imprimantă">
     Opțiuni finisor imprimantă
    </a>
   </p>
   <div id="divd0e30538">
    <p class="toc-2-style">
     <a href="using-staple-finisher-topic.html#using-staple-finisher_ro" title="Utilizarea finisorului cu capse">
      Utilizarea finisorului cu capse
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-staple-hole-punch-finisher-topic.html#using-staple-hole-punch-finisher_ro" title="Utilizarea finisorului cu capse și perforare">
      Utilizarea finisorului cu capse și perforare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-offset-stacker-topic.html#using-offset-stacker_ro" title="Utilizarea stivuitorului offset">
      Utilizarea stivuitorului offset
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-booklet-finisher-topic.html#using-booklet-finisher_ro" title="Utilizarea finisorului de broșuri">
      Utilizarea finisorului de broșuri
     </a>
    </p>
    <p class="toc-2-style">
     <a href="using-hptfu-topic.html#using-hptfu_ro" title="Utilizarea transportului h&acirc;rtiei cu opțiunea de pliere">
      Utilizarea transportului h&acirc;rtiei cu opțiunea de pliere
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="maintain-printer-chapter.html#maintain-printer-chapter_ro" title="&Icirc;ntreținerea imprimantei">
     &Icirc;ntreținerea imprimantei
    </a>
   </p>
   <div id="divd0e30948">
    <p class="toc-2-style">
     <a href="checking-supplies-status-topic.html#checking-supplies-status_ro" title="Verificarea stării pieselor și consumabilelor">
      Verificarea stării pieselor și consumabilelor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-supply-notifications-topic.html#configuring-supply-notifications_ro" title="Configurarea notificărilor de aprovizionare">
      Configurarea notificărilor de aprovizionare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="setting-up-email-alert-topic.html#setting-up-email-alert_ro" title="Configurarea alertelor prin poștă electronică">
      Configurarea alertelor prin poștă electronică
     </a>
    </p>
    <p class="toc-2-style">
     <a href="generating-reports-and-logs-topic.html#generating-reports-and-logs_ro" title="Generarea rapoartelor și jurnalelor">
      Generarea rapoartelor și jurnalelor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="ordering-parts-and-supplies-group.html#ordering-parts-and-supplies-group_ro" title="Comandarea pieselor și consumabilelor">
      Comandarea pieselor și consumabilelor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="replacing-toner-cartridge-topic.html#d0e31803" title="&Icirc;nlocuirea pieselor și consumabilelor">
      &Icirc;nlocuirea pieselor și consumabilelor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="cleaning-printer-topic.html#d0e32427" title="Curățarea componentelor imprimantei">
      Curățarea componentelor imprimantei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="configuring-power-save-mode-settings-topic.html#d0e32591" title="Economisirea de energie și h&acirc;rtie">
      Economisirea de energie și h&acirc;rtie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="moving-printer-topic.html#moving-printer_ro" title="Mutarea imprimantei &icirc;n altă locaţie">
      Mutarea imprimantei &icirc;n altă locaţie
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="troubleshooting-chapter.html#troubleshooting-chapter_ro" title="Depanarea unei probleme">
     Depanarea unei probleme
    </a>
   </p>
   <div id="divd0e32729">
    <p class="toc-2-style">
     <a href="print-quality-problems-topic.html#print-quality-problems_ro" title="Probleme legate de calitatea imprimării">
      Probleme legate de calitatea imprimării
     </a>
    </p>
    <p class="toc-2-style">
     <a href="printer-error-codes-topic.html#printer-error-codes_ro" title="Codurile de eroare ale imprimantei">
      Codurile de eroare ale imprimantei
     </a>
    </p>
    <p class="toc-2-style">
     <a href="solving-printing-problems.html#solving-printing-problems_ro" title="Probleme de imprimare">
      Probleme de imprimare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-printer-not-responding-topic.html#trb-printer-not-responding_ro" title="Imprimanta nu răspunde">
      Imprimanta nu răspunde
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-unable-to-read-flash-drive-topic.html#trb-unable-to-read-flash-drive_ro" title="Nu se poate citi unitatea flash">
      Nu se poate citi unitatea flash
     </a>
    </p>
    <p class="toc-2-style">
     <a href="enabling-usb-port-topic.html#enabling-usb-port_ro" title="Activarea portului USB">
      Activarea portului USB
     </a>
    </p>
    <p class="toc-2-style">
     <a href="clearing-jams.html#clearing-jams_ro" title="&Icirc;ndepărtarea blocajelor">
      &Icirc;ndepărtarea blocajelor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-open-embedded-web-server-topic.html#d0e36153" title="Probleme de conectare la rețea">
      Probleme de conectare la rețea
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-detect-internal-option-topic.html#d0e36246" title="Probleme legate de opțiunile hardware">
      Probleme legate de opțiunile hardware
     </a>
    </p>
    <p class="toc-2-style">
     <a href="message-replace-cartridge-printer-region-mismatch-topic.html#d0e36419" title="Probleme cu consumabilele">
      Probleme cu consumabilele
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-paper-curl-topic.html#d0e36567" title="Probleme cu alimentarea de h&acirc;rtie">
      Probleme cu alimentarea de h&acirc;rtie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="disabling-smtp-server-not-setup-error-topic.html#d0e36761" title="Probleme cu e-mailul">
      Probleme cu e-mailul
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-caller-id-not-shown-topic.html#d0e36816" title="Probleme la expedierea faxurilor">
      Probleme la expedierea faxurilor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-cannot-scan-to-computer-topic.html#d0e37138" title="Probleme de scanare">
      Probleme de scanare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="modifying-colors-in-printed-output-topic.html#d0e37556" title="Probleme legate de calitatea culorilor">
      Probleme legate de calitatea culorilor
     </a>
    </p>
    <p class="toc-2-style">
     <a href="trb-contacting-customer-support-topic.html#trb-contacting-customer-support_ro" title="Contactarea serviciului de asistență pentru clienți">
      Contactarea serviciului de asistență pentru clienți
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="recycle-dispose-chapter.html#recycle-dispose-chapter_ro" title="Reciclare și eliminare">
     Reciclare și eliminare
    </a>
   </p>
   <div id="divd0e37782">
    <p class="toc-2-style">
     <a href="recycling-lexmark-products-topic.html#recycling-lexmark-products_ro" title="Reciclarea produselor Lexmark">
      Reciclarea produselor Lexmark
     </a>
    </p>
    <p class="toc-2-style">
     <a href="recycling-lexmark-packaging-topic.html#recycling-lexmark-packaging_ro" title="Reciclarea ambalajelor Lexmark">
      Reciclarea ambalajelor Lexmark
     </a>
    </p>
   </div>
   <p class="toc-1-style">
    <a href="laser_ug_notices.html#laser_ug_notices_ro" title="Note">
     Note
    </a>
   </p>
   <div id="divd0e37818">
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37821" title="Informații despre produs">
      Informații despre produs
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37838" title="Notă asupra ediției">
      Notă asupra ediției
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#trademarks_ro" title="Mărci comerciale">
      Mărci comerciale
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#licensing-notices_ro" title="Note de licenţă">
      Note de licenţă
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#noise-emission-levels_ro" title="Niveluri de poluare fonică">
      Niveluri de poluare fonică
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#weee-directive_ro" title="Directiva WEEE (Waste from Electrical and Electronic Equipment - Deşeuri din echipamente electrice şi electronice)">
      Directiva WEEE (Waste from Electrical and Electronic Equipment - Deşeuri din echipamente electrice şi electronice)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37944" title="Baterie re&icirc;ncărcabilă litiu-ion">
      Baterie re&icirc;ncărcabilă litiu-ion
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#eu-battery-directive-2023-1542_ro" title="Regulamentul (UE) 2023/1542">
      Regulamentul (UE) 2023/1542
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e37982" title="Environmental labeling for packaging">
      Environmental labeling for packaging
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#product-disposal_ro" title="Dezafectarea produsului">
      Dezafectarea produsului
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#returning-lexmark-cartridges-for-reuse-or-recycling_ro" title="Returnarea cartuşelor Lexmark pentru reutilizare sau reciclare">
      Returnarea cartuşelor Lexmark pentru reutilizare sau reciclare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#static-sensitivity-notice_ro" title="Notificare de sensibilitate statică">
      Notificare de sensibilitate statică
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#energy-star_ro" title="ENERGY STAR">
      ENERGY STAR
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#temperature-information_ro" title="Informații cu privire la temperatură">
      Informații cu privire la temperatură
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#laser-notice_ro" title="Notă cu privire la laser">
      Notă cu privire la laser
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#power-consumption_ro" title="Consum de energie">
      Consum de energie
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38243" title="Notificări &icirc;n legătură cu reglementările privind produsele care utilizează comunicaţiile fără fir">
      Notificări &icirc;n legătură cu reglementările privind produsele care utilizează comunicaţiile fără fir
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#modular-component-notice_ro" title="Notificare privind componentele modulare">
      Notificare privind componentele modulare
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#exposure-to-radio-frequency-radiation_ro" title="Expunerea la radiaţii de radio-frecvenţă">
      Expunerea la radiaţii de radio-frecvenţă
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#d0e38268" title="Conformitate cu directivele Comunităţii Europene (CE)">
      Conformitate cu directivele Comunităţii Europene (CE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#european-community-ec-directives-conformity-class-a_ro" title="Conformitate cu directivele Comunităţii Europene (CE)">
      Conformitate cu directivele Comunităţii Europene (CE)
     </a>
    </p>
    <p class="toc-2-style">
     <a href="laser_ug_notices.html#radio-interference-notice_ro" title="Notă cu privire la interferenţele radio">
      Notă cu privire la interferenţele radio
     </a>
    </p>
   </div>
  </div>
 </div>
</template>
<script>
 import output from './output.json';

const fuzzysort = require('fuzzysort');
const lunr = require("lunr")
require("lunr-languages/lunr.stemmer.support.js")(lunr)
require('lunr-languages/lunr.multi')(lunr)
require("lunr-languages/tinyseg.js")(lunr)
require("lunr-languages/lunr.de.js")(lunr)
require("lunr-languages/lunr.es.js")(lunr)
require("lunr-languages/lunr.fr.js")(lunr)
require("lunr-languages/lunr.it.js")(lunr)
require("lunr-languages/lunr.ja.js")(lunr)
require("lunr-languages/lunr.pt.js")(lunr)

export default {
  name: 'app',
  data() {
    return {
        search: '',
        resultsActual: '',
        list: output,
        resultsCount: 0,
    }
  },

  methods: { queryResults() {

      if (this.search.trim() === ''){
        return  '';
      }
    //   else if(this.search.trim().length < 3){
    //     this.resultsActual = new Array();
    //     this.resultsCount = 0;
    //   }
      else {
        var documents = this.list;

        var idx = lunr(function () {
            this.use(lunr.ja);
            this.use(lunr.multiLanguage('en', 'de', 'es', 'fr', 'it', 'ja', 'pt'))
            this.ref('UUID');
            this.field('title');
            this.field('descFull');
            this.metadataWhitelist = ['position'];

            documents.forEach(function (doc) {
                        this.add(doc)
                    },this);
            });
        

        var searchTerms = this.search.replace(/[`~!#$%^&*()|+\-=?;:'",.<>\{\}\[\]\\/]/gi, ' ').trim().replace(/\s\s+/g, " ");
        // var searchTerms = this.search;
        searchTerms = this.removeStopWords(searchTerms);
        var searchRawTerms = searchTerms;
        // searchTerms  =  searchTerms.split(" ").join(" +");
        // searchTerms = searchTerms.startsWith(" +") ? searchTerms : "+" + searchTerms;

        console.log(searchTerms);
        var results = idx.search(searchTerms);

        console.log (results);

        results = results.map(res => {
            var linkRes =  documents.find(elem => elem.UUID == res.ref);
            var keywords_array = new Array();
            var keywords_arrays = new Array();
            var keywords_arrays_title = new Array();

            Object.keys(res.matchData.metadata).map(kys => {
                var positions_title = res.matchData.metadata[kys].title;
                var positions_desc = res.matchData.metadata[kys].descFull;

                if(typeof positions_title !== 'undefined' ){
                    positions_title.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays_title.push(val[0],val[1]);
                    });
                }

                if(typeof positions_desc !== 'undefined' ){
                    positions_desc.position.forEach(function(val, i, arr){
                        keywords_array.push(linkRes.descFull.substring(val[0],val[0] + val[1]));
                        keywords_arrays.push(val[0],val[1]);
                    });
                }
            });

            

            res.link = linkRes.link;
            res.desc = linkRes.desc;
            res.title = linkRes.title;
            res.full = linkRes.descFull;
            res.titleArray = keywords_arrays_title;
            res.descArray = keywords_arrays;
            keywords_array = keywords_array.filter(function(item, index){ 
                return searchRawTerms.indexOf(item) >= 0;
            });
            var keywords_set = new Set(keywords_array);
            res.keywords = [...keywords_set].toString();
            // res.keywords = ["ramon","joe","gudz"]
            return res;
        });
        
        var existingPagesInResult = new Array();
        

       
        results = results.filter(function(item, index){
                
            if(existingPagesInResult.includes(item.link)){
                
                return false;
            }
            else { 
                existingPagesInResult.push(item.link);
                return true;
            }

            if(res.keywords == ""){
                return false;
            }
        });

        

        console.log (results);
        this.resultsActual = results;
        this.resultsCount = results.length;
      }
    },

    clearResult: function(){
        this.search = "";
        this.resultsActual = undefined;
        this.resultsCount = 0;
        reload("cover.html", "");
       
    },  

    removeStopWords: function(queryString) {
        const stopWords = ['i', 'me', 'my', 'myself', 'we', 'our', 'ours', 'ourselves', 'you', "you're", "you've", "you'll", "you'd", 'your', 'yours', 'yourself', 'yourselves', 
        'he', 'him', 'his', 'himself', 'she', "she's", 'her', 'hers', 'herself', 'it', "it's", 'its', 'itself', 'they', 'them', 'their', 'theirs', 'themselves', 'what', 'which', 
        'who', 'whom', 'this', 'that', "that'll", 'these', 'those', 'am', 'is', 'are', 'was', 'were', 'be', 'been', 'being', 'have', 'has', 'had', 'having', 'do', 'does', 'did', 
        'doing', 'a', 'an', 'the', 'and', 'but', 'if', 'or', 'because', 'as', 'until', 'while', 'of', 'at', 'by', 'for', 'with', 'about', 'against', 'between', 'into', 'through', 
        'during', 'before', 'after', 'above', 'below', 'to', 'from', 'up', 'down', 'in', 'out', 'on', 'off', 'over', 'under', 'again', 'further', 'then', 'once', 'here', 'there', 
        'when', 'where', 'why', 'how', 'all', 'any', 'both', 'each', 'few', 'more', 'most', 'other', 'some', 'such', 'no', 'nor', 'not', 'only', 'own', 'same', 'so', 'than', 'too', 
        'very', 's', 't', 'can', 'will', 'just', 'don', "don't", 'should', "should've", 'now', 'd', 'll', 'm', 'o', 're', 've', 'y', 'ain', 'aren', "aren't", 'couldn', "couldn't", 
        'didn', "didn't", 'doesn', "doesn't", 'hadn', "hadn't", 'hasn', "hasn't", 'haven', "haven't", 'isn', "isn't", 'ma', 'mightn', "mightn't", 'mustn', "mustn't", 'needn', 
         "needn't", 'shan', "shan't", 'shouldn', "shouldn't", 'wasn', "wasn't", 'weren', "weren't", 'won', "won't", 'wouldn', "wouldn't"]

        var cleanQueryString = new Array();
        queryString.split(" ").forEach(word => {
             if(!stopWords.includes(word)) {
                 cleanQueryString.push(word);
             }
        });

        return cleanQueryString.join(" ");
    },
    
  }
}
</script>


// WEBPACK FOOTER //
// src/App.vue